import axiosIns from '@/libs/axios'

export default {
  namespaced: true,
  state: {},
  getters: {},
  mutations: {},
  actions: {
    fetchBrands(ctx, queryParams) {
        return new Promise((resolve, reject) => {
          axiosIns.get('/product_brands/list', {params:queryParams})
          .then(response => resolve(response))
          .catch(error => reject(error))
        })
    },
    fetchBrand(ctx, id) {
      return new Promise((resolve, reject) => {
        axiosIns.get(`/product_brands/${id}`)
        .then(response => resolve(response))
        .catch(error => reject(error))
      })
    },
    addBrand(ctx, data) {
        return new Promise((resolve, reject) => {
            axiosIns.post('/product_brands', data)
            .then(response => resolve(response))
            .catch(error => reject(error))
        })
    }

  },
}
